export const daily_events = [
  {
    day: 'Tue',
    name: 'Family Meeting',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Wed',
    name: 'Classic Wednesday ',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Thu',
    name: 'Live Thursdays',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Fri',
    name: 'Lift Off Friday',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Sat',
    name: 'RoofTop Mix ',
    description: 'Prepared reservation for parties of 1 of 8',
  },
  {
    day: 'Sun',
    name: 'Sip, Paint & Roast',
    description: 'Prepared reservation for parties of 1 of 8',
  },
];

export const isTerrace_Color = {
  primary: '#013709',
  background: '#fff',
  mainbg: '#fbf4e3',
};
export const isForno_Color = {
  primary: '#1d2b1a',
  background: '#fff',
  mainbg: '#ede9d0',
};

export const isReisty_Color = {
  primary: '#BC172F',
  background: '#fff',
  mainbg: '#fff',
};

export const isPrive_Color = {
  primary: '#ffffff',
  onPrimary: '#000000',
  background: '#000000',
  mainbg: '#000000',
  surface: '#111111',
  border: '#2a2a2a',
  text: '#ffffff',
  textMuted: '#a3a3a3',
  inputBg: '#1a1a1a',
};
export const isNok_Color = {
  // Brand
  primary: '#AE5830',
  primaryHover: '#C66A3D',
  primaryDark: '#8E4526',

  onPrimary: '#FFFFFF',

  // Backgrounds
  background: '#FAF8F6',
  mainbg: '#F5F1EE',

  // Surfaces
  surface: '#FFFFFF',
  inputBg: '#FFFFFF',

  // Borders
  border: '#E5DCD7',

  // Text
  text: '#241612',
  textMuted: '#786A64',
};

export const isMaisonPrive = (slug) =>
  slug === 'maison-prive' || slug === 'prive';

export const isDarkWidgetColor = (colors) => colors?.background === '#000000';

/** Outlined CTA styles that stay readable on dark maison-prive theme */
export const getWidgetOutlinedButtonSx = (currentColor) => {
  const isDark = isDarkWidgetColor(currentColor);

  return {
    color: currentColor?.text ?? '#111827',
    borderColor: isDark
      ? (currentColor?.primary ?? '#ffffff')
      : (currentColor?.border ?? '#e5e7eb'),
    '&:hover': {
      borderColor: currentColor?.primary ?? 'primary.main',
      bgcolor: isDark ? 'rgba(255, 255, 255, 0.06)' : 'transparent',
    },
  };
};

/** ReactQuill house rules body — readable on dark maison-prive theme */
export const houseRulesContentSx = {
  color: 'text.primary',
  '& .ql-editor': {
    padding: 0,
    color: 'inherit',
  },
  '& .ql-editor p, & .ql-editor ol, & .ql-editor ul, & .ql-editor li': {
    color: 'inherit',
  },
};

export function formatDate(inputDate) {
  // Create a Date object
  const date = new Date(inputDate);

  // Define an array of day and month names
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthsOfYear = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Extract the day of the week, month, and day of the month
  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = monthsOfYear[date.getMonth()];
  const dayOfMonth = date.getDate();

  // Format the date string
  const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}`;

  return formattedDate;
}

export function formatLongDate(inputDate) {
  if (!inputDate) return '--';
  const date = new Date(inputDate);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

/** ticket.reisty.com event URL — name slug + event id */
export function getEventTicketUrl(event) {
  if (!event) return null;

  const eventName = event.EventName;
  const eventId = event.RestaurantId;

  if (!eventName || !eventId) return null;

  const slug = eventName.trim().replace(/\s+/g, '-');

  return `https://ticket.reisty.com/event/${encodeURIComponent(slug)}/${eventId}?utm_source=website`;
}
